import { Component, Input, ElementRef, AfterViewInit, OnInit  } from "@angular/core";
import { GameService } from "src/app/shared/services/game/game.service";

@Component({
    selector: "app-jump-list",
    templateUrl: "./jump-list.component.html",
    styleUrls: ["./jump-list.component.scss"]
})
export class JumpListComponent  implements OnInit, AfterViewInit{

    @Input() prizeGrid?: ElementRef["nativeElement"];
    @Input() myPrizeList?: ElementRef["nativeElement"];
    @Input() activity?: ElementRef["nativeElement"];
    private jumpList;
    constructor(public gameService: GameService) {
        
    }
    ngAfterViewInit(): void {
        this.gameService.gamePointsUpdatedObservable.subscribe((gamePoints) => {
            this.jumpList?.classList?.remove("hidden");
        });
    }
    ngOnInit(): void {
        this.jumpList = document.querySelector(".jump-list__container");
        this.jumpList?.classList?.add('hidden');
    }
}